export default "__VITE_ASSET__3c21c1c5__"